import {Observable} from 'rxjs';

export interface Level {
    id?: number;
    code: string;
    description: string;
    level: number;
    active?: boolean;
    parent_id?: number | null;
    parent?: Level | null;
}

export abstract class LevelsData {
    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;
    abstract get(id: number): Observable<Level>;
    abstract getByLevel(level: number): Observable<Level[]>;
    abstract update(level: Level): Observable<Level>;
    abstract create(level: Level): Observable<Level>;
    abstract delete(level: Level): Observable<Level>;
}

